import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
import ServiceCTA from '../../components/ServiceCTA';
import RelatedServices from '../../components/RelatedServices';
import { Link } from 'react-router-dom';

const WebService = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center fade-in">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
              Webサイト制作・デザイン
            </h1>
            <p className="text-xl text-gray-700">
              あなたのお店の魅力をわかりやすく伝える、やさしいホームページを制作します。
            </p>
          </div>
        </div>
      </section>

      {/* Main Content - 2 Column Layout */}
      <section className="section-spacing bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left Column - Main Content */}
              <div className="lg:col-span-2 space-y-8">
                {/* Image */}
                <div className="rounded-2xl overflow-hidden shadow-md">
                  <img 
                    src="https://images.unsplash.com/photo-1707836868495-3307d371aba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx3ZWJzaXRlJTIwZGVzaWduJTIwbW9ja3VwfGVufDB8fHx8MTc2NDY1MzY3MXww&ixlib=rb-4.1.0&q=85"
                    alt="Webサイトデザイン"
                    className="w-full h-auto object-cover"
                  />
                </div>

                {/* Problems Section */}
                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    こんなことでお困りではありませんか？
                  </h2>
                  <ul className="space-y-3">
                    {[
                      'ホームページがなくて、お店の情報が伝わらない',
                      '作りたいけど、何から始めていいかわからない',
                      '古いホームページで、スマホで見にくい',
                      '制作会社に頼むと高くて手が出せない',
                      '更新や修正を自分でできない'
                    ].map((problem, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{problem}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Service Content */}
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    サービス内容
                  </h2>
                  
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        シンプルで優しいデザイン
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        お店の雰囲気に合わせた、見やすくて使いやすいデザインをご提案します。派手すぎず、お客様が必要な情報をすぐに見つけられるように工夫します。
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        スマホ対応（レスポンシブデザイン）
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        今の時代、お客様の多くはスマートフォンでお店を探します。スマホでも見やすく、操作しやすいホームページをお作りします。
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        文章作成・写真加工
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        「文章が苦手」「写真がない」という方もご安心ください。お店の魅力を伝える文章の作成や、写真の撮影・編集もお任せください。
                      </p>
                    </div>
                  </div>
                </div>

                {/* What You Can Do */}
                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスでできること
                  </h2>
                  <ul className="space-y-3">
                    {[
                      'お店の基本情報（営業時間、アクセス、メニュー）をわかりやすく掲載',
                      '新規のお客様にお店を知ってもらう',
                      'お客様からのお問い合わせ・予約を受けつける',
                      'お店のこだわりや想いを伝える',
                      '信頼感を与えて、来店を促す'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Who It's For */}
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスが向いている方
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '初めてホームページを作る飲食店や美容院',
                      '古いホームページを新しくしたい個人事業主',
                      'スマホ対応のページが欲しい方',
                      '予約フォームやお問い合わせフォームが欲しい方',
                      'デジタルが苦手で、全部お任せしたい方'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <Sparkles className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Post-Production Support */}
                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    制作後のサポートについて
                  </h2>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Webサイトは作って終わりではありません。公開後も安心してお使いいただけるよう、充実したサポート体制をご用意しています。
                  </p>
                  <ul className="space-y-3">
                    {[
                      'サーバー・ドメインの管理代行',
                      '営業時間やメニューなどの情報更新',
                      'セキュリティ対策とバックアップ',
                      '困ったときの迅速な対応',
                      'アクセス状況のレポート提供'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-6 p-4 bg-white rounded-lg">
                    <p className="text-sm text-gray-600">
                      ※ 月額5,000円～のホスティング＆Web管理プランをご用意しています。
                    </p>
                    <Link 
                      to="/pricing"
                      className="inline-block mt-3 text-[#F7C9D3] hover:text-[#2C2C2C] font-medium text-sm"
                    >
                      プラン詳細を見る →
                    </Link>
                  </div>
                </div>
              </div>

              {/* Right Column - Sidebar */}
              <div className="lg:col-span-1 space-y-6">
                {/* Price Box */}
                <div className="bg-white rounded-2xl p-6 shadow-md border-2" style={{ borderColor: '#F7C9D3' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    料金の目安
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">ライトプラン</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>30,000円～</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">スタンダード</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>80,000円～</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">プレミアム</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>150,000円～</p>
                    </div>
                    <Link 
                      to="/pricing" 
                      className="block text-center text-sm text-[#F7C9D3] hover:text-[#2C2C2C] font-medium mt-4"
                    >
                      詳しい料金を見る →
                    </Link>
                  </div>
                </div>

                {/* Points Box */}
                <div className="rounded-2xl p-6 shadow-sm" style={{ backgroundColor: '#FFF7FA' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    このサービスのポイント
                  </h3>
                  <ul className="space-y-3">
                    {[
                      '小規模店舗でも始めやすい価格',
                      'スマホ対応でお客様に優しい',
                      '公開後のサポートも安心'
                    ].map((point, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-2 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-sm text-gray-700">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Small CTA */}
                <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                  <p className="text-sm text-gray-600 mb-4">
                    このサービスについてもっと詳しく知りたい方
                  </p>
                  <Link 
                    to="/contact"
                    className="btn-primary block py-3 rounded-full font-medium text-sm"
                  >
                    無料相談はこちら
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <RelatedServices currentService="web" />

      {/* CTA Section */}
      <ServiceCTA />
    </div>
  );
};

export default WebService;